// iSupply Messenger Attribution v3 — fetch interceptor with cookie persistence
// Loaded as an external Shopify asset to bypass Liquid script-stripping.
// v3: persists attribution params to cookies so returning customers keep attribution.
(function () {
  if (window.__isupplyAttributionLoaded) return;
  window.__isupplyAttributionLoaded = true;

  var COOKIE_NAMES = {
    psid: '_isupply_psid',
    ext_id: '_isupply_ext_id',
    fbclid: '_isupply_fbclid',
    ad_id: '_isupply_ad_id', campaign_id: '_isupply_campaign_id', adset_id: '_isupply_adset_id', page_id: '_isupply_page_id',
    click_from: '_isupply_click_from'
  };

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (!match) return '';
    try { return decodeURIComponent(match[2]); } catch (e) { return match[2]; }
  }

  function setCookie(name, value, days) {
    if (!value) return;
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    var maxAge = days ? '; max-age=' + (days * 86400) : '';
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/' + secure + '; SameSite=Lax' + maxAge;
  }

  function buildAttribution() {
    var raw = {};
    // Read from URL params first (first visit with attribution)
    var urlParams = {
      psid: getParam('psid'),
      ext_id: getParam('ext_id'),
      fbclid: getParam('fbclid'),
      ad_id: getParam('ad_id'), campaign_id: getParam('campaign_id'), adset_id: getParam('adset_id'), page_id: getParam('page_id'),
      click_from: getParam('click_from')
    };
    // For each field: use URL param if present, otherwise fall back to cookie
    var allKeys = Object.keys(urlParams);
    for (var i = 0; i < allKeys.length; i++) {
      var key = allKeys[i];
      var urlVal = urlParams[key];
      var cookieVal = getCookie(COOKIE_NAMES[key]);
      var val = urlVal || cookieVal;
      if (val) raw[key] = val;
      // If URL param is present, persist it to cookie (30 days)
      if (urlVal) setCookie(COOKIE_NAMES[key], urlVal, 30);
    }
    return raw;
  }

  function writeCartAttributes(attribution) {
    if (!Object.keys(attribution).length) return;
    var noteAttributes = Object.keys(attribution).map(function (key) {
      return { name: '_isupply_' + key, value: String(attribution[key]) };
    });
    window.isupplyAttribution = attribution;
    console.log('[isupplyAttribution] Writing cart attributes:', JSON.stringify(noteAttributes));
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note_attributes: noteAttributes }),
      credentials: 'same-origin'
    }).catch(function (err) {
      console.error('[isupplyAttribution] cart/update error:', err.message);
    });
  }

  // Intercept fetch to inject note_attributes into the COD order request
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('isupply_cod_order') !== -1 && init && init.body) {
      try {
        var payload = JSON.parse(init.body);
        // Rebuild attribution from URL params + cookies (not stale window.isupplyAttribution)
        var attribution = buildAttribution();
        if (Object.keys(attribution).length) {
          payload.note_attributes = Object.keys(attribution).map(function (key) {
            return { name: '_isupply_' + key, value: String(attribution[key]) };
          });
          if (attribution.ext_id && payload.tracking) {
            payload.tracking.external_id = attribution.ext_id;
          }
          init.body = JSON.stringify(payload);
          console.log('[isupplyAttribution] Injected note_attributes into COD order request');
        }
      } catch (e) {
        console.error('[isupplyAttribution] fetch intercept error:', e.message);
      }
    }
    return originalFetch.apply(this, arguments);
  };

  function init() {
    var attribution = buildAttribution();
    writeCartAttributes(attribution);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
